import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DashboardLayout from '@/components/feature/DashboardLayout';
import { reiniciarTour } from '@/lib/tourBoasVindas';

const orientacoesCadastro = [
  {
    passo: 1,
    titulo: 'cadastre o condomínio',
    descricao: 'Sem o condomínio base não é possível iniciar os demais cadastros.',
    acao: 'Ir para condomínios',
    link: '/condominios',
  },
  {
    passo: 2,
    titulo: 'clique aqui para cadastrar uma torre',
    descricao:
      'Depois de criar o condomínio, cadastre as torres para distribuir os itens obrigatórios.',
    acao: 'Cadastrar torre',
    link: '#',
  },
  {
    passo: 3,
    titulo: 'depois das torres, cadastre as unidades',
    descricao: 'As unidades viabilizam os controles de ocupação e operação diária.',
    acao: 'Cadastrar unidades',
    link: '#',
  },
  {
    passo: 4,
    titulo: 'finalize itens compartilhados e individuais',
    descricao:
      'Preencha Bombeiros e Licenças (compartilhados) e Manutenções por torre (individuais).',
    acao: 'Finalizar pendências',
    link: '#',
  },
];

export default function AjudaPage() {
  const [tourRestarted, setTourRestarted] = useState(false);
  const navigate = useNavigate();

  const refazerTour = () => {
    // `reiniciarTour` reabre o tour no primeiro passo mesmo com o componente ja
    // montado: apagar a chave do `localStorage` daqui nao bastava, porque nada
    // desmonta `WelcomeTour` ao trocar de tela.
    reiniciarTour();
    setTourRestarted(true);
    setTimeout(() => {
      navigate('/dashboard');
    }, 400);
  };

  return (
    <DashboardLayout>
      <div className="max-w-3xl">
        <div className="mb-8">
          <h1 className="text-2xl md:text-3xl font-bold text-foreground-900">Central de Ajuda</h1>
          <p className="text-sm text-foreground-600 mt-1">
            Guia passo a passo para configurar seus condomínios corretamente.
          </p>
        </div>

        {/* Tour de boas-vindas */}
        <div className="bg-accent-50/50 border border-accent-200/50 rounded-lg p-5 md:p-6 mb-8">
          <div className="flex items-start justify-between gap-4">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center shrink-0">
                <i className="ri-compass-3-line text-accent-600"></i>
              </div>
              <div>
                <h2 className="text-base font-semibold text-foreground-900">Tour de boas-vindas</h2>
                <p className="text-sm text-foreground-600 mt-0.5">
                  Um guia rápido pelos principais recursos da plataforma — Dashboard, Condomínios,
                  Saúde e Pendências e mais.
                </p>
              </div>
            </div>
            <button
              onClick={refazerTour}
              disabled={tourRestarted}
              className="shrink-0 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {tourRestarted ? (
                <>
                  Redirecionando <i className="ri-loader-4-line animate-spin"></i>
                </>
              ) : (
                <>
                  Refazer tour <i className="ri-compass-3-line"></i>
                </>
              )}
            </button>
          </div>
        </div>

        {/* Tours Contextuais */}
        <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 mb-8">
          <div className="flex items-center gap-2 mb-5">
            <div className="w-9 h-9 rounded-lg bg-primary-50 flex items-center justify-center">
              <i className="ri-guide-line text-primary-600"></i>
            </div>
            <div>
              <h2 className="text-base font-semibold text-foreground-900">Guias contextuais</h2>
              <p className="text-sm text-foreground-600">
                Cada fluxo tem seu próprio tour. Refaça qualquer um deles abaixo.
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {[
              {
                key: 'tour_condominio_cadastro',
                titulo: 'Cadastro de Condomínio',
                desc: 'Como cadastrar, buscar e gerenciar condomínios.',
                icon: 'ri-building-line',
                link: '/condominios',
              },
              {
                key: 'tour_torres_cadastro',
                titulo: 'Cadastro de Torres',
                desc: 'Como adicionar blocos, configurar andares e características físicas.',
                icon: 'ri-building-4-line',
                link: '/condominios/condo-1/torres',
              },
              {
                key: 'tour_imoveis_cadastro',
                titulo: 'Cadastro de Imóveis',
                desc: 'Como cadastrar unidades, proprietários e gerenciar status.',
                icon: 'ri-home-4-line',
                link: '/condominios/condo-1/imoveis',
              },
              {
                key: 'tour_funcionarios_treinamentos',
                titulo: 'Funcionários e Treinamentos',
                desc: 'Como cadastrar colaboradores e gerenciar certificações e vencimentos.',
                icon: 'ri-team-line',
                link: '/condominios/condo-1/funcionarios',
              },
              {
                key: 'tour_treinamentos_gestao',
                titulo: 'Gestão de Treinamentos',
                desc: 'Visão consolidada de todos os treinamentos, filtros e alertas de vencimento.',
                icon: 'ri-award-line',
                link: '/dashboard/treinamentos',
              },
            ].map((tour) => (
              <div
                key={tour.key}
                className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-background-100/50 border border-background-200/70 rounded-lg p-4"
              >
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-lg bg-primary-50 flex items-center justify-center shrink-0">
                    <i className={`${tour.icon} text-primary-600`}></i>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800">{tour.titulo}</p>
                    <p className="text-sm text-foreground-600 mt-0.5">{tour.desc}</p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    localStorage.removeItem(tour.key);
                    navigate(tour.link);
                  }}
                  className="shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded-md border border-background-300/60 text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap self-start sm:self-center"
                >
                  Refazer tour
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-secondary-50/50 border border-secondary-200/50 rounded-lg p-5 md:p-6 mb-8">
          <div className="flex items-center gap-2 mb-5">
            <div className="w-9 h-9 rounded-lg bg-secondary-100 flex items-center justify-center">
              <i className="ri-clipboard-line text-secondary-600"></i>
            </div>
            <div>
              <h2 className="text-base font-semibold text-foreground-900">
                Orientações de cadastro
              </h2>
              <p className="text-sm text-foreground-600">
                Siga a sequência recomendada para concluir os cadastros sem retrabalho.
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {orientacoesCadastro.map((item) => (
              <div
                key={item.passo}
                className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-background-50 border border-background-200/70 rounded-lg p-4"
              >
                <div className="flex items-start gap-3">
                  <div className="w-7 h-7 rounded-full bg-primary-500 text-background-50 text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">
                    {item.passo}
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-800">
                      Passo {item.passo}: {item.titulo}
                    </p>
                    <p className="text-sm text-foreground-600 mt-0.5">{item.descricao}</p>
                  </div>
                </div>
                <Link
                  to={item.link}
                  className="shrink-0 inline-flex items-center gap-1.5 px-4 py-2 rounded-md border border-background-300/60 text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap self-start sm:self-center"
                >
                  {item.acao}
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-lg bg-primary-50 flex items-center justify-center">
              <i className="ri-question-line text-primary-600"></i>
            </div>
            <div>
              <h2 className="text-base font-semibold text-foreground-900">Perguntas frequentes</h2>
              <p className="text-sm text-foreground-600">Dúvidas comuns sobre a plataforma.</p>
            </div>
          </div>

          <div className="flex flex-col gap-1">
            {[
              {
                q: 'Como cadastrar um novo condomínio?',
                a: 'Acesse Condomínios no menu lateral e clique em "Novo Condomínio". Preencha os dados de endereço e uso da edificação.',
              },
              {
                q: 'Como adicionar uma torre?',
                a: 'Dentro do condomínio, vá na aba Torres e clique em "Nova Torre". Informe o nome e quantidade de andares.',
              },
              {
                q: 'O que fazer quando um alvará vence?',
                a: 'Vá até Licenças ou Alvarás dentro do condomínio, localize o documento vencido e clique em "Renovar" para registrar a nova versão.',
              },
              {
                q: 'Como configurar notificações?',
                a: 'O super administrador pode acessar Administração → Notificações para definir os prazos de antecedência dos alertas.',
              },
              {
                q: 'Como interpretar os KPIs do dashboard?',
                a: 'Os cards mostram o total de cada categoria (treinamentos, alvarás). A barra colorida indica a proporção de itens vigentes (verde), próximos do vencimento (âmbar) e vencidos (vermelho).',
              },
            ].map((faq, idx) => (
              <details
                key={idx}
                className="group border-b border-background-200/50 last:border-b-0"
              >
                <summary className="flex items-center justify-between py-3 cursor-pointer text-sm font-medium text-foreground-800 hover:text-foreground-900 list-none">
                  {faq.q}
                  <div className="w-5 h-5 flex items-center justify-center text-foreground-400 group-open:hidden shrink-0 ml-2">
                    <i className="ri-add-line"></i>
                  </div>
                  <div className="w-5 h-5 hidden items-center justify-center text-foreground-400 group-open:flex shrink-0 ml-2">
                    <i className="ri-subtract-line"></i>
                  </div>
                </summary>
                <p className="pb-3 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </details>
            ))}
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
